/**
 * Labstep
 *
 * @module components/Entity/Detail/Table
 * @desc Table for entity detail
 */

import { HorizontalTable } from 'labstep-web/core/Table/Horizontal';
import type React from 'react';
import type { EntityDetailTableProps } from './types';

export const EntityDetailTable: React.FC<EntityDetailTableProps> = ({
  rows,
  columns,
  dataCy,
  noMargin,
}) => (
  <HorizontalTable
    dataCy={dataCy}
    padded={!noMargin}
    noMargin={noMargin}
    borderless
    headerProps={{ width: 6 }}
    rows={rows}
    columns={columns}
  />
);
